export default "__VITE_ASSET__T64eyX$o__"